import {
    FETCH_MAILING_LIST_REQUEST,
    FETCH_MAILING_LIST_SUCCESS,
    FETCH_MAILING_LIST_FAILURE,
    CREATE_MAILING_LIST_REQUEST,
    CREATE_MAILING_LIST_SUCCESS,
    CREATE_MAILING_LIST_FAILURE,
    UPDATE_MAILING_LIST_REQUEST,
    UPDATE_MAILING_LIST_SUCCESS,
    UPDATE_MAILING_LIST_FAILURE,
    DELETE_MAILING_LIST_REQUEST,
    DELETE_MAILING_LIST_SUCCESS,
    DELETE_MAILING_LIST_FAILURE,
} from '../actions/mailingListActions';

const initialState = {
    mailingList: {
        loading: false,
        error: null,
        data: [],
    },
    create: {
        loading: false,
        error: null,
        success: false,
    },
    update: {
        loading: false,
        error: null,
        success: false,
    },
    delete: {
        loading: false,
        error: null,
        success: false,
    },
};

const mailingListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MAILING_LIST_REQUEST:
            return {
                ...state,
                mailingList: {
                    loading: true,
                    error: null,
                    data: [],
                },
            };

        case FETCH_MAILING_LIST_SUCCESS:
            // L'API peut retourner directement un tableau ou un objet
            let mailingListData = action.payload || [];
            if (!Array.isArray(mailingListData)) {
                // Si c'est un objet, essayer d'extraire le tableau
                mailingListData = mailingListData.data || mailingListData.records || mailingListData.items || mailingListData.results || [];
                if (!Array.isArray(mailingListData)) {
                    mailingListData = [];
                }
            }
            return {
                ...state,
                mailingList: {
                    loading: false,
                    error: null,
                    data: mailingListData,
                },
            };

        case FETCH_MAILING_LIST_FAILURE:
            return {
                ...state,
                mailingList: {
                    loading: false,
                    error: action.payload,
                    data: [],
                },
            };

        case CREATE_MAILING_LIST_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_MAILING_LIST_SUCCESS:
            // Optimistic update: ajouter la nouvelle entrée si elle est retournée par l'API
            // Sinon, on laissera le fetch rafraîchir la liste
            const newEntry = action.payload;
            let updatedMailingList = state.mailingList.data;
            
            // Si l'API retourne la nouvelle entrée créée, l'ajouter optimistiquement
            if (newEntry && (newEntry.email_id || newEntry.id)) {
                const existingData = Array.isArray(state.mailingList.data) ? state.mailingList.data : [];
                // Vérifier si l'entrée n'existe pas déjà pour éviter les doublons
                const entryExists = existingData.some(
                    (entry) => (entry.email_id || entry.id) === (newEntry.email_id || newEntry.id)
                );
                if (!entryExists) {
                    updatedMailingList = [...existingData, newEntry];
                }
            }
            
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                },
                mailingList: {
                    ...state.mailingList,
                    data: updatedMailingList,
                },
            };

        case CREATE_MAILING_LIST_FAILURE:
            // Rollback: retirer l'entrée ajoutée optimistiquement en cas d'erreur
            // On va recharger la liste depuis le serveur pour être sûr d'avoir l'état correct
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
                // Ne pas restaurer manuellement, laisser le fetch rafraîchir
            };

        case UPDATE_MAILING_LIST_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_MAILING_LIST_SUCCESS:
            // Optimistic update: mettre à jour l'entrée dans la liste si elle est retournée par l'API
            const updatedEntry = action.payload;
            let updatedMailingListData = state.mailingList.data;
            
            if (updatedEntry && (updatedEntry.email_id || updatedEntry.id)) {
                const existingData = Array.isArray(state.mailingList.data) ? state.mailingList.data : [];
                updatedMailingListData = existingData.map((entry) => {
                    const entryId = entry.email_id || entry.id;
                    const updatedId = updatedEntry.email_id || updatedEntry.id;
                    if (entryId === updatedId) {
                        return updatedEntry;
                    }
                    return entry;
                });
            }
            
            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                },
                mailingList: {
                    ...state.mailingList,
                    data: updatedMailingListData,
                },
            };

        case UPDATE_MAILING_LIST_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_MAILING_LIST_REQUEST:
            // Optimistic update: retirer immédiatement l'entrée de la liste
            const emailIdToDeleteOptimistic = action.payload;
            const optimisticData = Array.isArray(state.mailingList.data)
                ? state.mailingList.data.filter(
                      (entry) => entry.email_id !== emailIdToDeleteOptimistic && entry.id !== emailIdToDeleteOptimistic
                  )
                : [];
            
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
                // Mise à jour optimiste de l'UI
                mailingList: {
                    ...state.mailingList,
                    data: optimisticData,
                },
            };

        case DELETE_MAILING_LIST_SUCCESS:
            // La suppression optimiste a déjà été faite, on confirme juste le succès
            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case DELETE_MAILING_LIST_FAILURE:
            // Rollback: restaurer l'entrée supprimée en cas d'erreur
            // On va recharger la liste depuis le serveur pour être sûr d'avoir l'état correct
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
                // Ne pas restaurer manuellement, laisser le fetch rafraîchir
            };

        default:
            return state;
    }
};

export default mailingListReducer;
